import Phaser from "phaser";
import { GAME_FONT } from "../text.js";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("Boot");
  }

  create(): void {
    // Canvas text is rasterized once, so the web font must be ready first.
    const start = () => this.scene.start("Preload");
    Promise.all([
      document.fonts.load(`8px ${GAME_FONT}`),
      document.fonts.load(`bold 8px ${GAME_FONT}`),
    ]).then(start, start);
  }
}
